export const initialState = {
	activeStep: 0,
	completedSteps: {},
	contactData: undefined,
	contactFound: false,
	contactHasOrdered: false,
	contactSearchedFor: false,
	defaultsAppliedForClientLocationKey: '',
	emailAddress: '',
	formSubmitted: false,
	formValues: undefined,
	initialPartnerSelectionSet: false,
	isCodeValid: false,
	partnerList: undefined,
	selectedClientId: '',
	selectedClientLocationId: '',
};

export const reducer = (state, action) => {
	switch (action.type) {
		case 'completeStep': {
			return {
				...state,
				completedSteps: {
					...state.completedSteps,
					[action.payload.name]: true,
				},
			};
		}
		case 'resetState': {
			return {
				...initialState,
				...action.payload,
			};
		}
		case 'setStateValue':
			return {
				...state,
				[action.payload.key]: action.payload.value,
			};
		case 'submitAnotherRequest': {
			return {
				...state,
				activeStep: action.payload.activeStep,
				formSubmitted: false,
				formValues: {
					...state.formValues,
					deliveryDate: '',
				},
			};
		}
		default:
			return state;
	}
};
